import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import useDraftSettings from "../../hooks/queryResults/draft/useDraftSettings";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import Loading from "../ui/Loading";

export default function DraftStartsCountdown() {
  const { draftSettingsData, draftSettingsQuery } = useDraftSettings();
  const isLoading = useIsLoading(draftSettingsData, draftSettingsQuery);

  const [clock, setClock] = useState(null);

  let settingsStartDate = null;
  if (!isLoading) {
    settingsStartDate = draftSettingsData.settings.startDate;
  }

  useEffect(() => {
    let diff;
    let interval;

    if (settingsStartDate) {
      interval = setInterval(() => {
        const now = moment();
        const startDate = moment(settingsStartDate);
        diff = startDate.diff(now);

        if (diff <= 0) {
          setClock("0s");
        } else {
          setClock(Math.floor(diff / 1000));
        }
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [settingsStartDate]);

  const formatClock = () => {
    if (!_.isNumber(clock)) return clock;
    let rem;
    const days = Math.floor(clock / (3600 * 24));
    rem = clock - days * 3600 * 24;
    const hours = Math.floor(rem / 3600);
    rem -= hours * 3600;
    const minutes = Math.floor(rem / 60);
    rem -= minutes * 60;
    const seconds = rem;

    let out = `${_.padStart("" + seconds, 2, "0")}s`;

    if (days > 0 || hours > 0 || minutes > 0)
      out = `${_.padStart("" + minutes, 2, "0")}m ${out}`;

    if (days > 0 || hours > 0)
      out = `${_.padStart("" + hours, 2, "0")}h ${out}`;

    if (days > 0) out = `${days}d ${out}`;

    return out;
  };

  if (isLoading) return <Loading />;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: "0.5rem",
      }}
    >
      <span style={{ textAlign: "center" }}>
        <span style={{ fontSize: "0.8rem", color: "#666666" }}>
          Draft starts in:
        </span>
        <br />
        <span style={{ fontSize: "1.25rem" }}>{formatClock()}</span>
      </span>
    </div>
  );
}
